<div class="panel-wrapper" cdkDrag>
  <div class="searcher-panel" [@searcherPanel]="isSearcherPanelOpen ? 'open' : 'closed'" *ngIf="isSearcherPanelOpen">
    <div class="searcher-panel-header">
      <div class="searcher-panel-header-text">
        <h3>Buscar en: <span class="title-layer">{{ selectedSearchSource?.displayName }}</span></h3>
        <label>(<span class="subtitle-total">{{ searcherTotalResults }}</span>)</label>
      </div>
      <img class="close-searcher-button" [src]="'cancelar.svg' | findUrl" (click)="closeSourceSearcher()">
    </div>
    <div class="searcher-panel-content">
      <app-annotation-searcher *ngIf="selectedSearchSource"
        [sourceName]="selectedSearchSource.name"
        [displayAttribute]="selectedSearchSource.displayAttribute"
        [isSearchDisabled]="searcherTotalResults === 'Cargando...' || searcherTotalResults === '0'"
        (searchTotal)="updateSearchTotal($event)">
      </app-annotation-searcher>
    </div>
  </div>

  <div class="floating-panel" [class.minimized]="isMinimized">
    <div class="panel-header" cdkDragHandle>
      <h2 [class.hidden]="isMinimized">Capas</h2>
      <div class="header-buttons">
        <mat-icon class="refresh-button" [class.hidden]="isMinimized" matTooltip="Actualizar" (click)="refreshSources()">refresh</mat-icon>
        <mat-icon class="minimize-button" matTooltip="{{isMinimized ? 'Expandir acotaciones' : 'Minimizar'}}" (click)="toggleMinimize()">
          {{isMinimized ? 'chevron_left' : 'chevron_right'}}
        </mat-icon>
      </div>
    </div>
    
    <div class="panel-content" [class.hidden]="isMinimized">
      <div class="switch-container" [cdkDropListData]="visibleSources" cdkDropList (cdkDropListDropped)="onDropSource($event)">
        <ng-container *ngFor="let source of visibleSources">
          <div class="switch-item" cdkDrag>
            <div class="switch-searcher">
              <mat-icon *ngIf="source.visible && selectedSearchSource?.name !== source.name && source.canBeSearched" class="search-icon" (click)="openSourceSearcher(source)" matTooltip="Buscar ubicación">arrow_back_ios</mat-icon>
              <mat-icon *ngIf="source.visible && selectedSearchSource?.name === source.name && source.canBeSearched" class="search-icon" (click)="openSourceSearcher(source)" matTooltip="Buscar ubicación">arrow_forward_ios</mat-icon>
            </div>
            <div class="switch-content">
              <label class="switch" [id]="source.name">
                <img *ngIf="source.visible" [src]="'btn_on.svg' | findUrl" class="img-button" (click)="onToggleSourceVisibility(source)">
                <img *ngIf="!source.visible" [src]="'btn_off.svg' | findUrl" class="img-button" (click)="onToggleSourceVisibility(source)">
              </label>
              <img *ngIf="source.icon" [src]="source.icon | findUrl" class="source-icon" [title]="source.icon">
              <span class="source-name" [title]="source.name">
                {{ source.displayName }}
              </span>
            </div>
          </div>
        </ng-container>
        
        <div *ngIf="visibleSources.length === 0" class="no-layers-message">
          No hay capas disponibles
        </div>
      </div>
    </div>
  </div>
</div>
